import type { PlatformComponentProps } from "@b2bportal/core-types";
import type { Map } from "google-maps-react-markers";
import type Supercluster from "supercluster";

export interface PointerProperties<T> {
  data: T;
  label: string;
  pointerId: string;
}

export enum MapMarkerType {
  CLUSTER = "CLUSTER",
  SINGLE = "SINGLE",
}

interface CommonMapMarkerProps extends PlatformComponentProps {
  isHighlighted?: boolean;

  lat: number;
  lng: number;
  markerId: string;
  mapRef: React.MutableRefObject<Map>;
  label: string;
  buttonProps?: React.ButtonHTMLAttributes<HTMLButtonElement>;
  onClick: () => void;
}

export interface ClusterMarkerProps<T> extends CommonMapMarkerProps {
  markerType: MapMarkerType.CLUSTER;
  cluster: Supercluster.PointFeature<
    Supercluster.ClusterProperties & Supercluster.AnyProps
  >;
}

export interface SingleMarkerProps<T> extends CommonMapMarkerProps {
  markerType: MapMarkerType.SINGLE;
  cluster: Supercluster.PointFeature<PointerProperties<T>>;
  isSelected?: boolean;
  onClose?: () => void;
  sortIndex: number;
}

export type MapMarkerComponentProps<T> =
  | ClusterMarkerProps<T>
  | SingleMarkerProps<T>;
